<mat-dialog-content>{{ 'loginDialog.text' | translate }}</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
    <button style="margin-left: 8px" mat-raised-button class="color" (click)="onLogin()">{{ 'loginDialog.button' | translate }}</button>
</mat-dialog-actions>
